import {NavbarMode} from '@navbar-unlogged-types';
import {NAVBAR_MODE_URL_MAP, normalizeNavbarPath} from '../config/navbarModeUrlMap';

type ModePrefixEntry = {
    mode: NavbarMode;
    prefix: string;
};

const MODE_PREFIX_ENTRIES: ModePrefixEntry[] = (() => {
    const entries: ModePrefixEntry[] = [];

    for (const url of NAVBAR_MODE_URL_MAP[NavbarMode.FREELANCER].urls) {
        entries.push({mode: NavbarMode.FREELANCER, prefix: normalizeNavbarPath(url)});
    }

    return entries.sort((a, b) => b.prefix.length - a.prefix.length);
})();

export function pathMatchesNavbarModePrefix(path: string, prefix: string): boolean {
    return path === prefix || path.startsWith(`${prefix}/`);
}

export function resolveNavbarModeFromPath(path: string, defaultMode: NavbarMode = NavbarMode.CLIENT): NavbarMode {
    const normalizedPath = normalizeNavbarPath(path);

    for (const {mode, prefix} of MODE_PREFIX_ENTRIES) {
        if (pathMatchesNavbarModePrefix(normalizedPath, prefix)) {
            return mode;
        }
    }

    return defaultMode;
}
